/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { useState, createRef, useEffect } from 'react';
import {
    object, shape, string, func, bool,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Modal from '@material-ui/core/Modal';
import { addCGCLabelsDataToApi } from '../../../../../state/ducks/CGC/CGC-Actions';
import { getGCIPersonalizationKey, getCustomCardData, getDataDictionary } from '../../../../../state/ducks/App/App-Selectors';
import SelectCelebrationsCustomsCard from './SelectCustoms/SelectCelebrationsCustomsCard';
import PersonalizeCustoms from './PersonalizeCustoms/PersonalizeCustoms';
import { extractImageFileExtensionFromBase64 } from './ImageCropUtils';
import CGCModalHeader from '../CGCModalHeader';
import CelebrationsCustomModalNav from './CelebrationsCustomModalNav';
import ReviewCustom from './ReviewCustom/ReviewCustom';

const styles = (theme) => ({
    title: {
        fontSize: 28,
        textAlign: 'center',
        padding: '24px 0px',
    },
    container: {
        position: 'absolute',
        top: 50,
        left: '50%',
        transform: 'translateX(-50%)',
        maxWidth: 1280,
        width: '80%',
        background: theme.palette.cgc?.bgColor || 'white',
        '&:focus': {
            outline: 'none',
        },
        [theme.breakpoints.down('sm')]: {
            minWidth: '100%',
            height: '100%',
            top: 0,
        },
    },
});
const CelebrationsCustomsCardView = ({
    customsData, classes, closeModal, updateCGCCustomsData, gciKey, orderItemsId, addCGCData, customType, openModal, customCardData, existingData, dataDictionary,
}) => {
    const [customsCardType, setCustomsCardType] = useState('');
    const [customView, setCustomView] = useState('select');
    const [image, setImage] = useState('');
    const [imageExt, setImageExt] = useState('jpg');
    const [message, setMessage] = useState('');
    const [croppedImage, setcroppedImage] = useState('');
    const imagePreviewCanvasRef = createRef(null);
    const customsCard = customsData?.label_image?.url;
    const customCardStyling = customsData?.message_image_settings;
    // add CGC Customs data to api and redux

    const resetState = () => {
        setCustomsCardType('');
        setImage('');
        setImageExt('');
        setMessage('');
    };

    useEffect(() => {
        if (existingData && Object.keys(existingData).length) {
            const messageData = {
                text: existingData.message_body,
                style: {
                    fontSize: existingData.font_size,
                    fontFamily: existingData.font_family,
                    color: existingData.text_color,
                    textAlign: existingData.text_alignment,
                },
            };
            setCustomsCardType(existingData.label_type);
            setImage(`data:${existingData.cover_image_mimes};base64,${existingData.cover_image}`);
            setImageExt(existingData.cover_image_mimes);
            setMessage(messageData);
        }
    }, [existingData]);

    useEffect(() => {
        if (typeof customCardData === 'object' && !customCardData?.thumbnail) {
            resetState();
        }
    }, [customCardData]);

    const addCustomsCard = () => {
        if (image !== '' || message?.text) {
            const data = {
                text: message.text,
                thumbnail: customsCard,
                action: 'personalizationComplete',
            };
            const imageConverted = croppedImage;
            if (updateCGCCustomsData) {
                updateCGCCustomsData({ sku: customsData.sku, key_id: gciKey, ...data  });
            }
            // customType is for labels or hangtags and customCardType is for photo, message or both,
            addCGCData({
                key_id: gciKey, cardData: customsData, message, imageConverted, cgcData: { orderItemsId }, customsCardType, customType,
            });
            closeModal();
        }
    };

    const handleImage = (e) => {
        const currentFile = e.target.files[0];
        const myFileItemReader = new FileReader();
        myFileItemReader.addEventListener('load', () => {
            const myResult = myFileItemReader.result;
            setImage(myResult);
            setImageExt(extractImageFileExtensionFromBase64(myResult));
        }, false);
        myFileItemReader.readAsDataURL(currentFile);
    };
    const MODAL_VIEWS = {
        SELECT_TEMPLATE: 'select',
        PERSONALIZE: 'personalize',
        REVIEW: 'review',
    };
    const handleCustom = (type) => {
        setCustomsCardType(type);
        setCustomView(MODAL_VIEWS.PERSONALIZE);
    };
    const handlePersonalize =  () => {
        const canvasRef = imagePreviewCanvasRef.current;
        const imageData64 = canvasRef?.toDataURL(`image/${imageExt}`);
        setcroppedImage(imageData64);
        setCustomView(MODAL_VIEWS.REVIEW);
    };
    return (
        <Modal open={openModal}>
            <Grid container className={classes.container}>
                <CGCModalHeader
                    closeModal={closeModal}
                    dataDictionary={dataDictionary}
                />
                <CelebrationsCustomModalNav
                    modalViews={MODAL_VIEWS}
                    selectedView={customView}
                    selectedCard={customsCard}
                    messageData={message}
                    setCustomView={setCustomView}
                    dataDictionary={dataDictionary}
                />
                <Grid container>
                    {MODAL_VIEWS.SELECT_TEMPLATE === customView
                    &&                            (
                        <SelectCelebrationsCustomsCard
                            customsCard={customsCard}
                            setCustomsCardType={handleCustom}
                            dataDictionary={dataDictionary}
                        />
                    )}
                    {MODAL_VIEWS.PERSONALIZE === customView
                    &&                        (
                        <PersonalizeCustoms
                            customData={customsData}
                            customsCard={customsCard}
                            customsCardType={customsCardType}
                            image={image}
                            message={message}
                            setImage={setImage}
                            setMessage={setMessage}
                            personalizeCustomsCard={handlePersonalize}
                            handleImage={handleImage}
                            customCardStyling={customCardStyling}
                            imagePreviewCanvasRef={imagePreviewCanvasRef}
                            dataDictionary={dataDictionary}
                        />
                    )}
                    {MODAL_VIEWS.REVIEW === customView
                    && (
                        <ReviewCustom
                            customData={customsData}
                            customsCard={customsCard}
                            customsCardType={customsCardType}
                            message={message}
                            croppedImage={croppedImage}
                            addCustomsCard={addCustomsCard}
                            dataDictionary={dataDictionary}
                        />
                    )}
                </Grid>
            </Grid>
        </Modal>
    );
};
CelebrationsCustomsCardView.propTypes = {
    classes: object.isRequired,
    customsData: shape({
        label_image: shape({
            url: string.isRequired,
        }),
    }),
    orderItemsId: string.isRequired,
    gciKey: string,
    closeModal: func.isRequired,
    updateCGCCustomsData: func.isRequired,
    addCGCData: func.isRequired,
    customType: string.isRequired,
    openModal: bool.isRequired,
    customCardData: shape({
        thumbnail: string,
    }).isRequired,
    existingData: shape({
        cover_image: string,
        message_body: string,
        label_type: string,
    }),
    dataDictionary: object,
};

CelebrationsCustomsCardView.defaultProps = {
    customsData: {},
    gciKey: '',
    existingData: {},
    dataDictionary: {},
};
const mapStateToProps = (state) => ({
    gciKey: getGCIPersonalizationKey(state),
    existingData: getCustomCardData(state),
    dataDictionary: getDataDictionary(state),
});
const mapDispatchToProps = (dispatch) => ({
    addCGCData: bindActionCreators(addCGCLabelsDataToApi, dispatch),
});
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CelebrationsCustomsCardView));
